const queryMap = {};

export const invertedQueryMap = Object.fromEntries(Object.entries(queryMap).map((n) => [n[1], n[0]]));

export default queryMap;
